import { createRouter, createWebHistory } from 'vue-router'
//import { createRouter } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../components/ContenidoMain.vue')
  },

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/registra',
    name: 'registra',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegistroWeb.vue')
  },
  {
    path: '/contenido',
    name: 'contenido',
    component: () => import(/* webpackChunkName: "about" */ '../components/ContenidoMain.vue')
  },
  {
    path: '/menuheader',
    name: 'menuheader',
    component: () => import(/* webpackChunkName: "about" */ '../components/MenuHeader.vue')
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactoWeb.vue')
  },
  {
    path: '/servicios',
    name: 'servicios',
    component: () => import(/* webpackChunkName: "servicios" */ '../views/ServicesView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true, hideHeaderFooter: true }
  },
  {
    path: '/cotizaciones/ingreso',
    name: 'Cotizaciones',
    component: () => import('../components/CotizacionesView.vue'),
    meta: { requiresAuth: true, hideHeaderFooter: true }
  },
  {
    path: '/cotizaciones/mantencion',
    name: 'MantencionCotizaciones',
    component: () => import('../components/MantencionCotizacionesView.vue'),
    meta: { requiresAuth: true, hideHeaderFooter: true }
  },
  {
    path: '/roadmap',
    name: 'Roadmap',
    component: () => import('../views/RoadmapView.vue'),
    meta: { requiresAuth: true, hideHeaderFooter: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  }
})

// Guardia de navegación para proteger rutas
router.beforeEach((to, from, next) => {
    const isLoggedIn = !!localStorage.getItem('isLoggedIn');

    // Si la ruta requiere autenticación y el usuario no está logueado
    if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
        next('/login'); // Redirigir al login
    } else {
        next(); // Permitir el paso
    }
});

export default router
